import Vue from 'vue'
import router from './router'
import store from './store'
import installComponent from './components'
import 'normalize.css'
import './styles/index.scss'
import App from './App.vue'

Vue.config.productionTip = false

installComponent()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
